export const LOADER_STEP_TIME = 4000; // Time in milliseconds for each step to load
export const LOADER_COMPLETE_DELAY = 300;
